import React, {RefObject, useLayoutEffect, useRef, useState} from 'react'

import ControlButtonStandard, {
    ControlButtonType
} from "../../../../../core/gd-components/buttons/control-button/control-button-standard"
import InputInlineEditable from "../../../../../core/gd-components/input-inline-editable/input-inline-editable"
import Button, {ButtonSize, ButtonType} from "../../../../../core/gd-components/buttons/gd-button/gd-button-ui5-new";
import NavigationMenuItemInput_IconComponent from "./icon-component"

type Props = {
    iconClass?      : string | false
    projectIcon?    : string
    color?          : number
    level?          : number
    parentId?       : ID | null
    value?          : string

    onCommit        : {(value?:string):void}
}

// const debug = "NavigationMenuItemInputCommon"
const debug = false

export default function NavigationMenuItemInputCommon(props: Props) {

    debug && console.log(debug, "render", props)

    let value       : string = props.value || ''
    const inputRef  : RefObject<any> = useRef<any>()

    const [isBusy, setIsBusy] = useState(false)

    useLayoutEffect(() => {
        value = props.value || ''
        inputRef.current.focus()
    }, []);


    const onImmediateChange = (newValue: string) => {
        value = newValue
    }

    const onChange = async (value?:string) => {
        setIsBusy(!!value)
        props.onCommit(value)
    }

    const onConfirm = () => {
        setIsBusy(true)
        inputRef.current.commit()
    }

    const onCancel = () => {
        props.onCommit()
    }

    debug && console.log(debug, 'render')

    const classes = Classes('item project', 'level-'+props.level)

    return (
        <div className={classes}>
            <div className="row">
                <div className="arrow hidden closed"/>
                <NavigationMenuItemInput_IconComponent projectIcon  = {props.projectIcon}
                                                       iconClass    = {props.iconClass}
                                                       color        = {props.color}/>

                <InputInlineEditable ref                = {inputRef}
                                     className          = "gd-input small name w-100-percent p-r-60"
                                     focusOnMount       = {true}
                                     value              = {value}
                                     autoSaveChanges    = {false}
                                     onImmediateChange  = {onImmediateChange}
                                     onChange           = {onChange}/>

                {!isBusy &&
                    <div className="actions flex-row-left-center">
                        <ControlButtonStandard className    = "blue-bg fs-11 m-r-3"
                                               type         = {ControlButtonType.OK}
                                               size         = {20}
                                               onClick      = {onConfirm}/>
                        <ControlButtonStandard className    = "hover-bg fs-11"
                                               type         = {ControlButtonType.CLOSE}
                                               size         = {20}
                                               onClick      = {onCancel}/>
                    </div>}

                {isBusy &&
                    <div className="actions flex-row-left-center">
                        <Button className   = "selected no-background w-40"
                                type        = {ButtonType.SECONDARY_BUSY}
                                size        = {ButtonSize.TINY}/>
                    </div>
                }
            </div>
        </div>
    )
}

NavigationMenuItemInputCommon.defaultProps = {
    level: 0
}
